import { supabaseClient } from "./supabaseClient.js";

async function checkPremiumStatus(userId) {
  try {
    const { data, error } = await supabaseClient
      .from("subscriptions")
      .select("subscription_status")
      .eq("user_id", userId)
      .maybeSingle();

    if (error && error.code !== "PGRST116") {
      console.error("Error checking premium status:", error);
      return false;
    }

    return data?.subscription_status === "active";
  } catch (error) {
    console.error("Error checking premium status:", error);
    return false;
  }
}

function initializeCheckoutHandler() {
  // Check for success param in URL
  const urlParams = new URLSearchParams(window.location.search);
  const checkoutStatus = urlParams.get("checkout");

  if (checkoutStatus === "success") {
    // Clear the URL parameter
    window.history.replaceState({}, "", "/");

    // Poll for subscription status
    let attempts = 0;
    const maxAttempts = 10;
    const interval = setInterval(async () => {
      attempts++;

      try {
        const {
          data: { session },
        } = await supabaseClient.auth.getSession();

        if (!session) {
          clearInterval(interval);
          return;
        }

        // Force a premium status check
        const premiumStatus = await checkPremiumStatus(session.user.id);
        if (premiumStatus) {
          document.body.classList.add("premium");
          clearInterval(interval);
          return;
        }

        if (attempts >= maxAttempts) {
          clearInterval(interval);
          console.log("Max attempts reached waiting for subscription status");
        }
      } catch (error) {
        console.error("Error checking subscription status:", error);
        clearInterval(interval);
      }
    }, 1000); // Check every second
  }
}

export function initializeStripeUI() {
  const premiumButtons = document.querySelectorAll(".header-premium-button");
  const manageSubscriptionButton = document.querySelector(".manage-subscription-button");

  // Initialize checkout handler
  initializeCheckoutHandler();

  // Add click handler to all premium buttons
  premiumButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      // Store original content for restoration
      const buttonOriginalContent = button.innerHTML;

      try {
        // Set loading state
        button.innerHTML = '<div class="spin"></div>';
        button.disabled = true;

        const {
          data: { session },
        } = await supabaseClient.auth.getSession();
        if (!session) {
          // Trigger auth button click if no session
          const authButton = document.querySelector(".auth-button");
          authButton?.click();
          return;
        }

        const response = await fetch("/.netlify/functions/stripeCreateCheckout", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${session.access_token}`,
          },
        });

        const { url, error, details } = await response.json();

        if (error) {
          console.error("Checkout error:", error, details);
          return;
        }

        // Redirect to Stripe Checkout
        window.location.href = url;
      } catch (error) {
        console.error("Checkout error:", error);
      } finally {
        // Restore original button state
        button.innerHTML = buttonOriginalContent;
        button.disabled = false;
      }
    });
  });

  manageSubscriptionButton?.addEventListener("click", async () => {
    try {
      // Disable button during processing
      manageSubscriptionButton.disabled = true;

      const {
        data: { session },
      } = await supabaseClient.auth.getSession();
      if (!session) {
        console.error("No active session");
        return;
      }

      // Create portal session
      const response = await fetch("/.netlify/functions/stripeCreatePortalSession", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session.access_token}`,
        },
      });

      const { url, error, details } = await response.json();

      if (error) {
        console.error("Portal session error:", error, details);
        return;
      }

      // Redirect to Stripe Portal
      window.location.href = url;
    } catch (error) {
      console.error("Portal session error:", error);
    } finally {
      manageSubscriptionButton.disabled = false;
    }
  });
}
